import React from "react";
import {
  LineChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Label,
} from "recharts";

export const SpecimensPerWeekGraph = ({ graphData, lines }) => {
  return (
    <>
      <div
        style={{ textAlign: "center", color: "#167bc3", fontFamily: "Roboto" }}
      >
        <h2>SPECIMENS IMAGED PER WEEK</h2>
      </div>
      <div
        style={{
          marginTop: "20px",
          height: "350px",
          width: "100%",
          fontSize: "11px",
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            width={500}
            height={300}
            data={graphData}
            margin={{
              top: 5,
              right: 5,
              left: 5,
              bottom: 20,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name">
              <Label
                value="WEEK"
                offset={0}
                position="insideBottom"
                style={{ fontSize: "12px", fontWeight: "bold" }}
              />
            </XAxis>
            <YAxis>
              <Label
                value="COUNT"
                angle={-90}
                position="insideLeft"
                style={{
                  textAnchor: "middle",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              />
            </YAxis>
            <Tooltip />
            {lines}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};
